<template>
  <div>Hub template - to be migrated</div>
</template>
